// extracted by mini-css-extract-plugin
export default {"content":"Main_content__EcgWZ","main":"Main_main__84C6X"};